import { sendGTMEvent } from "@next/third-parties/google";
import { isbot } from "isbot";
import { getPagePath } from "~/utils/pagePath";

export const sendGtmEvent = ({ event, value }) => {
    if (typeof window === "undefined" || isbot(navigator.userAgent)) {
        return;
    }

    // Don't mutate `value`: callers reuse event objects across pages
    sendGTMEvent({
        event,
        ...value,
        page_path: value.page_path || getPagePath(),
        referral_page: document.referrer,
    });
};
